import { INGEST_EXTENSIONS } from '@prism/contracts';

/**
 * The `accept` list for the upload picker: the MIME wildcards plus every
 * extension the server ingests, so types the OS does not map to video/* or
 * audio/* (MXF, MTS, BWF...) are still selectable, and graphics packages (.zip). Upper-case names match
 * because pickers compare extensions case-insensitively.
 */
export function uploadAccept(extensions: Iterable<string> = INGEST_EXTENSIONS): string {
  return ['video/*', 'audio/*', 'image/*', ...Array.from(extensions, (e) => `.${e}`)].join(',');
}
